export default __webpack_public_path__ + "static/media/text1.a81731e3.png";